import { Student } from '@/apis/family_application/requests'
import { Button } from '@/app/common/components/Button'
import { AppRoutePaths } from '@/routing/route_paths'
import { setEditMode } from '@/storage/applications/applicationStatusSlice'
import { setSelectedStudent } from '@/storage/applications/familyApplicationSlice'
import { AppDispatch } from '@/storage/store'
import { format, parse } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import StudentStatusBadge from '../components/StudentStatusBadge'
import { ReviewItem } from './ReviewItem'

type Props = {
  students: Student[]
  isPrint?: boolean
}

export function ReviewStudentDetails({ students, isPrint }: Props) {
  const { t: translate } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const getFormattedBirthDate = (dateString?:string|null) => {
    if(!dateString) return ""

    try {
      const date = parse(dateString, "yyyy-MM-dd", new Date());
     const formattedDate = format(date, "MM-dd-yyyy");
     return formattedDate
    } catch (error) {
      return dateString
    }
  }
  return (
    <div>
      {students.map((student) => {
        return (
          <div className="border-t border-grey-800 pb-3">
            {!isPrint &&
              <div className="mt-8 mb-2 flex justify-end">
                <Button
                  variant={'outline'}
                  onClick={() => {
                    dispatch(setEditMode("form-edit-student-details"))
                    dispatch(setSelectedStudent(student.id))
                    navigate(
                      AppRoutePaths.family_application.student_details
                        .enter_details
                    )
                  }}
                >
                  {translate('edit_student_details')}
                </Button>
              </div>
            }
            
            <ReviewItem
              title={translate('name')}
              value={`${student.first_name} ${student.last_name}`}
            />
            <ReviewItem
              title={translate('application_status')}
              value={
                <StudentStatusBadge status={student.application_status} subStatus={student.scholarship_application_sub_status} />
              }
            />
            <ReviewItem
              title={translate('date_of_birth_capital')}
              value={getFormattedBirthDate(student?.date_of_birth)}
            />
            <ReviewItem title={translate('grade')} value={student.grade} />

            <ReviewItem
              title={translate('relationship')}
              value={student.relationship?.replace('_', ' ')}
            />
          </div>
        )
      })}
    </div>
  )
}
